import type { InputHTMLAttributes, ReactNode } from 'react';

export type CheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  /** Com `label`, o checkbox fica dentro de um `<label>` (ex.: termos do onboarding). */
  label?: ReactNode;
  /** Classe do `<label>` (ex.: `terms`). */
  wrapperClassName?: string;
};

/** Checkbox do pacote (`.check`). */
export function Checkbox({ label, wrapperClassName, className = '', ...input }: CheckboxProps) {
  const box = <input className={['check', className].filter(Boolean).join(' ')} type="checkbox" {...input} />;
  if (!label) return box;
  return (
    <label className={wrapperClassName}>
      {box}
      <span>{label}</span>
    </label>
  );
}
